export const imageStyle = props => `
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: ${props.round ? '50%' : '3px'};
`;



// WEBPACK FOOTER //
// ./app/components/avatar/styles.jsx